import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Nullable } from '@ps/utils';
import {
  Feasibility,
  Survey,
  SurveyMetadataFormState,
  SurveyQualificationsFormState,
  SurveyQuotasFormState,
} from '@ps/survey-utils';

export const SurveyCreationActions = createActionGroup({
  source: 'Survey Creation',
  events: {
    Init: props<{ surveyId: Nullable<number> }>(),
    'Create Standard Survey': emptyProps(),
    'Update Metadata': props<{ metadata: SurveyMetadataFormState }>(),
    'Update Qualifications': props<{
      qualifications: SurveyQualificationsFormState;
    }>(),
    'Update Quotas': props<{ quotas: SurveyQuotasFormState }>(),
    'Save Survey': emptyProps(),
    Reset: emptyProps(),
  },
});

export const SurveyCreationApiActions = createActionGroup({
  source: 'Survey Creation API',
  events: {
    'Create Standard Survey Success': props<{ survey: Survey }>(),
    'Create Standard Survey Failure': props<{ error: string }>(),
    'Save Survey Success': props<{ survey: Survey }>(),
    'Save Survey Failure': props<{ error: string }>(),
    'Load Survey For Edit Success': props<{ survey: Survey }>(),
    'Load Survey For Edit Failure': props<{ error: string }>(),
  },
});

export const SurveyCreationNavbarActions = createActionGroup({
  source: 'Survey Creation Navbar',
  events: {
    'Toggle Manual Processing': props<{
      companyId: number;
      enabled: boolean;
    }>(),
    'Recalculate Feasibility': emptyProps(),
  },
});

export const SurveyCreationNavbarApiActions = createActionGroup({
  source: 'Survey Creation Navbar API',
  events: {
    'Compute Score Pending': emptyProps(),
    'Compute Score Success': props<{
      score: number;
      scorePercentage: number;
    }>(),
    'Compute Score Failure': props<{ error: string }>(),
    'Recalculate Feasibility Pending': emptyProps(),
    'Recalculate Feasibility Success': props<Feasibility>(),
    'Recalculate Feasibility Failure': props<{ error: string }>(),
  },
});
